import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useEffect, useRef, useState } from 'react';
import { descargaMonitorReporte, obtenerProyecto, obtenerPuesto, obtieneTurnosByPuestoFecha } from '../../services/Monitor/MonitorService';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

const ReporteMonitor = () => {
    const [proyecto, setProyecto] = useState();
    const [lstProyecto, setLstProyecto] = useState([]);
    const [cargaProyecto, setCargaProyecto] = useState(true);
    const [puesto, setPuesto] = useState();
    const [lstPuesto, setLstPuesto] = useState([]);
    const [cargaPuesto, setCargaPuesto] = useState(false);
    const [fecha, setFecha] = useState(null);
    const [formatFecha, setFormatFecha] = useState(null);
    const [loadTurno, setLoadTurno] = useState(false);
    const [turno, setTurno] = useState(null);
    const [lstTurno, setLstTurno] = useState([]);
    const [proceso, setProceso] = useState(false);

    const [datFechaIni, setDatFechaIni] = useState(new Date());
    const [datFechaFin, setDatFechaFin] = useState(new Date());

    const toast = useRef(null);

    useEffect(() => {
        const cargarProyecto = async () => {
            try {
                const datos = await obtenerProyecto();
                setLstProyecto(datos);
                setCargaProyecto(false);
            } catch (error) {
                console.error(error.message);
            }
        };
        cargarProyecto();
    }, []);

    useEffect(() => {
        const cargarPuesto = async () => {
            if (proyecto) {
                setCargaPuesto(true);
                try {
                    const datos = await obtenerPuesto(proyecto.id);
                    setLstPuesto(datos);
                } catch (error) {
                    console.error(error.message);
                }
                setCargaPuesto(false);
            }
        };
        cargarPuesto();
    }, [proyecto]);

    useEffect(() => {
        const cargarTurno = async () => {
            if (puesto && fecha) {
                try {
                    setLoadTurno(true);
                    const datos = await obtieneTurnosByPuestoFecha(puesto.id, formatFecha);
                    setLstTurno(datos);
                    setLoadTurno(false);
                } catch (error) {
                    console.error(error.message);
                }
            }
        };
        cargarTurno();
    }, [puesto, fecha]);

    const handleDatechange = (evt) => {
        setFecha(evt.value);
        const anio = evt.value.getFullYear();
        const mes = String(evt.value.getMonth() + 1).padStart(2, '0');
        const dia = String(evt.value.getDate()).padStart(2, '0');
        setFormatFecha(`${anio}-${mes}-${dia}`);
    };

    const turnoItemTemplate = (itemFila) => {
        if (itemFila) {
            return (
                <span>
                    {itemFila.horarioSigla} - {itemFila.horarioNombre}{' '}
                </span>
            );
        }
    };

    const turnoValueTemplate = (itemFila, props) => {
        if (itemFila) {
            return (
                <span>
                    {itemFila.horarioSigla} - {itemFila.horarioNombre}
                </span>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const convertFecha = (fechaHora) => {
        const yyyy = fechaHora.getFullYear();
        const mm = String(fechaHora.getMonth() + 1).padStart(2, '0');
        const dd = String(fechaHora.getDate()).padStart(2, '0');
        const hh = String(fechaHora.getHours()).padStart(2, '0');
        const mi = String(fechaHora.getMinutes()).padStart(2, '0');
        const ss = String(fechaHora.getSeconds()).padStart(2, '0');
        
        return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
    };

    const handleGeneraRep = async () => {
        /*console.log('WW01:', proyecto)
      console.log('WW02:', puesto)
      console.log('WW03:', formatFecha)
      console.log('WW04:', turno)*/

        /*if (!formatFecha) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: `Debe llenar el campo Fecha`, life: 3000 });
            return;
        }*/
       if (datFechaIni && datFechaFin) {
        const objData = {
            proyectoId: proyecto ? proyecto.id : null,
            puestoId: puesto ? puesto.id : null,
            //fechaReporte: formatFecha,
            dataFeHoraIni: convertFecha(datFechaIni),
            dataFeHoraFin: convertFecha(datFechaFin),
            horarioId: turno ? turno.horarioId : null
        };
        setProceso(true);
        try {
            const data = await descargaMonitorReporte(objData);
        } catch (error) {
            console.error('ERROR:' + error.message);
        } finally {
            setProceso(false);
        }
       } else {
        toast.current.show({ severity: 'warn', summary: 'Warning', detail: `Debe llenar los campos Fecha Hora`});
       }
        
    };

    return (
        <div className="card">
            <Toast ref={toast} />
            <h5>Reporte de Monitor</h5>
            <div className="formgrid grid p-fluid mb-3">
                {/* Fecha */}
                <div className="field col-12 md:col-3">
                    <label>Datos Fecha Inicio:</label>
                    <Calendar value={datFechaIni} onChange={(evt) => setDatFechaIni(evt.value)} showTime hourFormat="24" dateFormat="dd/mm/yy" />
                </div>
                <div className="field col-12 md:col-3">
                    <label>Datos Fecha Fin:</label>
                    <Calendar value={datFechaFin} onChange={(evt) => setDatFechaFin(evt.value)} showTime hourFormat="24" dateFormat="dd/mm/yy" />
                </div>
                {/* Proyecto */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboProyecto">Proyecto:</label>
                    {cargaProyecto ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown inputId="cboProyecto" value={proyecto} onChange={(evt) => setProyecto(evt.value)} options={lstProyecto} optionLabel="descripcion" placeholder="Elija un Proyecto" filter showClear />
                    )}
                </div>
                {/* Puesto */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboPuesto">Puesto:</label>
                    {cargaPuesto ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown inputId="cboPuesto" value={puesto} onChange={(evt) => setPuesto(evt.value)} options={lstPuesto} optionLabel="descripcion" placeholder="Elija un Puesto" filter showClear />
                    )}
                </div>

                {/* Turno */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboTurno">Turno</label>
                    {loadTurno ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown
                            id="cboTurno"
                            value={turno}
                            onChange={(evt) => setTurno(evt.value)}
                            options={lstTurno}
                            placeholder="Seleccione un Turno"
                            optionLabel="horarioSigla"
                            itemTemplate={turnoItemTemplate}
                            valueTemplate={turnoValueTemplate}
                            filter
                            showClear
                        />
                    )}
                </div>
                <div className="field col-12 md:col-6">
                    <span></span>
                </div>
                <div className="field col-12 md:col-6">
                    <Button label="Generar Reporte" loading={proceso} onClick={handleGeneraRep} />
                </div>
            </div>
        </div>
    );
};

export default ReporteMonitor;
